import DeleteNode from '../nodes/commands/types/delete';
import ExecuteNode from '../nodes/commands/types/execute';
import InsertNode from '../nodes/commands/types/insert';
import PrintNode from '../nodes/commands/types/print';
import PrintSchemaNode from '../nodes/commands/types/printSchema';
import RefreshNode from '../nodes/commands/types/refresh';
import SelectNode from '../nodes/commands/types/select';
import SleepNode from '../nodes/commands/types/sleep';
import StopNode from '../nodes/commands/types/stop';
import StopIfZeroNode from '../nodes/commands/types/stop-if-zero';
import UpdateNode from '../nodes/commands/types/update';
import ValidateNode from '../nodes/commands/types/validate';

const commands = [
  {
    type: 'deleteCommand',
    title: 'Delete Command',
    node: DeleteNode,
  },
  {
    type: 'executeCommand',
    title: 'Execute Command',
    node: ExecuteNode,
  },
  {
    type: 'insertCommand',
    title: 'Insert Command',
    node: InsertNode,
  },
  {
    type: 'printCommand',
    title: 'Print Command',
    node: PrintNode,
  },
  {
    type: 'printSchemaCommand',
    title: 'Print Schema Command',
    node: PrintSchemaNode,
  },
  {
    type: 'refreshCommand',
    title: 'Refresh Command',
    node: RefreshNode,
  },
  {
    type: 'selectCommand',
    title: 'Select Command',
    node: SelectNode,
  },
  {
    type: 'sleepCommand',
    title: 'Sleep Command',
    node: SleepNode,
  },
  {
    type: 'stopCommand',
    title: 'Stop Command',
    node: StopNode,
  },
  {
    type: 'stopifzeroCommand',
    title: 'Stop If Zero Command',
    node: StopIfZeroNode,
  },
  {
    type: 'updateCommand',
    title: 'Update Command',
    node: UpdateNode,
  },
  {
    type: 'validateCommand',
    title: 'Validate Command',
    node: ValidateNode,
  },
].sort((a, b) => a.title.localeCompare(b.title));

export default commands;
